"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    // ======================================================
    app: {
      about: 'über die Applikation.',
      actions: {
        add: 'hinzufügen',
        addNamed: 'hinzufügen {name}',
        remove: 'löschen',
        removeNamed: 'löschen {name}',
        removeConfirmation: 'Sind Sie sicher, dass Sie löschen möchten?',
        more: 'mehr',
        less: 'weniger',
        download: 'herunterladen',
        save: 'speichern',
        cancel: 'stornieren',
        close: 'schließen',
        moreFormFields: 'mehr Felder',
        export: 'exportieren',
        edit: 'bearbeiten',
        createdSuccessMessage: 'Erfolgreich erstellt.',
        savedSuccessMessage: 'Erfolgreich gespeichert.',
        deletedSuccessMessage: 'Erfolgreich gelöscht',
        detail: 'Detail',
        next: 'weiter',
        back: 'zurück',
        start: 'start',
        whatNext: 'Was kommt als nächstes...',
        confirm: 'Bestätigung',
        confirmRemove: 'Sind Sie sicher, dass Sie löschen möchten?',
        search: 'suchen',
        userProfile: 'Benutzerprofil',
        tenantProfile: 'Profil Ihres CRM',
        imports: 'Importe',
        fileImports: 'Datenimport',
        settings: 'Einstellungen',
        logout: 'Abmeldung',
        login: 'Anmeldung',
        filterList: 'Liste filtern',
        excel: 'Excel',
        refresh: 'erneuern',
        clear: 'räumen',
        agree: 'Stimme zu',
        disagree: 'Stimme nicht zu',
        makeCopy: 'Eine Kopie erstellen',
        fullscreen: 'Vollbildschirm',
        fullscreenClose: 'Vollbildschirm schließen',
        copy: 'kopieren'
      },
      messages: {
        confirmRemove: 'Möchten Sie diesen Artikel wirklich löschen?',
        errorOccurred: 'Ein Fehler ist aufgetreten',
        createdSuccess: 'Die Erstellung war erfolgreich.',
        savedSuccess: 'Das Speichern war erfolgreich.',
        deletedSuccess: 'Das Löschen war erfolgreich.',
        uploadSuccess: 'Datei erfolgreich hochgeladen.',
        uploadError: 'Fehler beim Hochladen der Datei.',
        uploadInProgress: 'Hochladen...',
        uploadedFiles: '{number, plural, eine {1 soubor byl uploadnutý} mehrere {{number} soubory byly uploadovány} andere {{number} souborů bylo uploadovaných}}'
      },
      error: 'Fehler!',
      validations: {
        isRequired: 'Feld {field} ist pflichtig.',
        minLengthIsRequired: 'Es ist mindestens erforderlich {number, plural, eine {1 položka} mehrere {{number} položky} andere {{number} položek}}.',
        minValue: 'Der minimal zulässige Wert ist {value}.',
        maxValue: 'Der maximal zulässige Wert ist {value}.',
        passwordMatchError: 'Passwörter stimmen nicht überein',
        invalidEmail: 'Ungültige E-Mail.',
        invalidPhoneNumber: 'Ungültige Telefonnummer. Geben Sie die Telefonnummer im internationalen Format  "+X XXX XXX XXX" ein.',
        notValidNumber: 'Ungültige Telefonnummer',
        invalidUrl: 'ungültige URL.',
        positive: 'Die Zahl muss positiv sein.',
        negative: 'Die Zahl muss negativ sein.'
      },
      login: {
        title: 'Anmeldung zu Sprinx CRM',
        username: 'Benutzername',
        password: 'Passwort',
        loginButton: 'Anmelden',
        error: 'Anmeldung hat fehlgeschlagen. Benutzername oder Passwort nicht gefunden',
        pleaseRelogin: 'Es sieht so aus, als wären Sie nicht angemeldet. Bitte melden Sie sich erneut an.'
      },
      days: '{count, plural, ein {1 den} mehrere {{formattedCount} dni} andere {{formattedCount} dní}}',
      // values { count, formattedCount}
      overdue: 'verspätung {count, plural, ein {1 den} few {{formattedCount} dni} mehrere {{formattedCount} dní}}',
      // values { count, formattedCount}
      newItem: 'Neu',
      anonymizing: {
        confirm: {
          title: 'Bestätigen Sie die Anonymisierung',
          content: 'Möchten Sie Ihre persönlichen Daten wirklich anonymisieren?'
        },
        button: 'Persönliche Daten anonymisieren'
      },
      appMenu: {
        discover: 'Entdecken'
      },
      missingType: 'Bitte definieren Sie dies in der Aplikationsverwaltung {typeName}.',
      missingTypeForEntityType: 'Bitte definieren Sie dies in der Aplikationsverwaltung {typeName} für {forEntityTypeName}.',
      emptyScoringBlog: 'Module, deren Inhalt oder Einstellungen auf dieser Seite angezeigt werden, sind nicht aktiviert.'
    },
    // ======================================================
    components: {
      buttons: {
        showOnMap: 'Auf der Karte anzeigen'
      },
      filters: {
        filterButtonSubmit: 'suchen',
        filterFieldName: '{name} ({conditionType})',
        addCondition: 'Bedingung hinzuügen',
        resetFilter: 'Filter reservieren',
        operators: {
          contains: {
            _: 'enthält',
            0: 'enthält'
          },
          containsexact: {
            _: 'enthält genau',
            0: 'enthält genau'
          },
          notcontains: {
            _: 'beinhaltet nicht',
            0: 'beinhaltet nicht'
          },
          betweennumber: {
            _: 'zwischen',
            0: 'von',
            1: 'bis'
          },
          betweendate: {
            _: 'zwischen',
            0: 'von',
            1: 'bis'
          },
          equal: {
            _: 'ist gleich',
            0: 'ist gleich'
          }
        }
      },
      paginationList: {
        itemsTotal: 'Artikel zusammen: {number}',
        nextPage: 'einlesen {number} Artikel',
        emptyMessage: 'Artikel nicht gefunfen.'
      },
      selects: {
        emptyOption: 'keine',
        emptyMessage: 'Artikel nicht gefunden.'
      },
      tables: {
        labelRowsPerPage: 'Zeilen auf der Seite',
        sortBy: 'Sortieren nach {field}',
        recordsChanged: 'Einige Einträge wurden hinzugefügt oder geändert.'
      },
      textField: {
        errorMsgWrapper: 'Fehler: {msg}'
      },
      dateField: {
        invalidDateFormat: 'Falsches Datumsformat.',
        invalidDate: 'Unbekannt',
        maxDateMessage: 'Das Datum darf nicht größer als das maximale Datum sein',
        minDateMessage: 'Das Datum darf nicht kleiner als der minimale Datum sein',
        today: 'Heute'
      },
      detailNavigation: {
        scoringblog: 'Scoring Blog',
        card: 'Karte',
        relations: 'Relation'
      },
      manipulationInfo: {
        created: 'erstellt',
        updated: 'geändert',
        removed: 'gelöscht'
      }
    }
  }
};
var _default = messages;
exports.default = _default;